import { AxiosResponse } from 'axios';
// import { publicInstance } from '../../api/axiosOfWeightService';
import { instance as axios } from 'api/axios';
import { WeightResponse } from './interfaces';

export class WeightService {
  public static async getWeight(url: string) {
    try {
      const response: AxiosResponse<WeightResponse> = await axios.get('/WeightClient', { params: { url: btoa(url) } });
      if (!response.data.success) {
        throw new Error(response.data.errorMessages.join(','));
      }

      if (response.data?.weightData.data === 'ERR') {
        throw new Error('Виникла помилка');
      }
      return response.data.weightData;
    } catch (error: any) {
      throw new Error(error.response?.data?.errorMessages || 'Виникла помилка');
    }
  }
}
